<div class="flex items-center justify-center h-full md:h-auto h-calc-content">
  <div
    class="bg-white rounded-lg w-full h-full md:h-auto md:w-[500px] p-6 md:relative"
  >
    <div>
      <!-- Título -->
      <h2 class="headline-06 mb-2" [ngClass]="{'text-[#134F82]': !isTenantMode, 'text-[#003746]': isTenantMode}">Código de verificación</h2>

      <!-- Subtítulo -->
      <div class="mb-4">
        <p class="text-sm text-gray-600">
          Enviamos un código de verificación a tu correo, ingrésalo aquí o
          solicita un nuevo código.<br />
          El código de verificación caduca después de 5 minutos.
        </p>
      </div>

      <!-- Campo: Código de verificación -->
      <mat-form-field appearance="fill" class="w-full mb-4 custom-input">
        <mat-label>Código de verificación</mat-label>
        <input matInput [formControl]="codigo" />
        <mat-error *ngIf="codigo?.hasError('required')"
          >Campo obligatorio</mat-error
        >
      </mat-form-field>
    </div>

    <p *ngIf="errorMensaje" class="text-[#BA1A1A] mb-4">{{ errorMensaje }}</p>

    <button
      class="w-full rounded-full text-white py-3"
      [ngClass]="{'bg-[#134F82]': !isTenantMode, 'bg-[#003746]': isTenantMode}"
      [disabled]="codigo.invalid"
      (click)="verificarCodigo()"
    >
      Verificar código
    </button>

    <div class="text-center m-1">
      <button
        class="text-sm font-semibold underline cursor-pointer bg-transparent border-none p-0"
        [ngClass]="{'text-[#134F82]': !isTenantMode, 'text-[#003746]': isTenantMode}"
        (click)="reenviarCodigo()">
        Enviar nuevo código
      </button>
    </div>
  </div>
</div>
